import React from 'react';
import {
  SimpleTeaser,
} from '../../../components';
import NodeVideoSelectionFull from './Full';

const NodeVideoSelection = (props) => {
  const { viewMode } = props;
  switch (viewMode) {
    case 'teaser':
      return <SimpleTeaser withSummary imageSrc={props.entity.getIn(['field_preview_video_url', 0, 'styles', 'large_teaser_image'])} {...props} />;
    default:
      return <NodeVideoSelectionFull {...props} />;
  }
};

export default NodeVideoSelection;
